<template lang="pug">
.container.grid-lg.py-2
  load-manager(:status="status")
    div(v-if="current")
      section.top-header
        .columns
          .column
            .my-1 {{ current | enums("doc.tipo") }} #[b {{ current.numero }}/{{ current.ano }}]
            label.label {{ current.situacao.descricao }}
          .column.col-auto.text-right
            a.btn.btn-link(:href="current.url", target="_blank")
              btn-content(label="Visualizar impressão", icon="fa fa-print")
            .abbr
              .label {{ current.created_at | date }}
        .divider
      section
        .columns(v-if="current.modelo")
          item-col.my-1.col-12(
            label="doc_modelo.titulo",
            :value="current.modelo.titulo"
          )
          item-col.my-1.col-12(
            label="doc_modelo.descricao",
            :value="current.modelo.descricao"
          )
        .columns
          item-col.my-1.col-auto.col-sm-6(
            label="doc.ciencia_em",
            :value="current.ciencia_em | date"
          )
          item-col.my-1.col-auto.col-sm-6(
            label="doc.reincidente",
            :value="current.reincidente"
          )
          item-col.my-1.col-auto.col-sm-6(
            label="doc.prazo_regularizar",
            :value="current.prazo_regularizar"
          )
          item-col.my-1.col-auto.col-sm-6(
            label="doc.regularizar_em",
            :value="current.regularizar_em | date('DD/MM/YYYY')"
          )
          item-col.my-1.col-6.col-sm-12(
            v-if="current.fiscal",
            label="doc.fiscal",
            :value="current.fiscal.nome"
          )
          item-col.my-1.col-6.col-sm-12(
            v-if="current.autor",
            label="doc.autor",
            :value="current.autor.nome"
          )
        .divider
      section(v-if="current.cadastro")
        h5.h5 {{ "doc.cadastro" | tModel }}
        .columns
          item-col.my-1.col-4.col-sm-12(
            label="cadastro.numero",
            :value="current.cadastro.numero"
          )
          item-col.my-1.col-4.col-sm-12(
            label="cadastro.tipo",
            :value="current.cadastro | enums('cadastro.tipo')"
          )
          item-col.my-1.col-12(
            v-if="current.cadastro.endereco_formatado",
            label="cadastro.endereco",
            :value="current.cadastro.endereco_formatado"
          )
        .columns
          item-col.my-1.col-12(
            v-if="current.cadastro.contribuinte",
            label="cadastro.contribuinte",
            :value="`${$options.filters.cpfCnpj(current.cadastro.contribuinte.cpf_cnpj)} - ${current.cadastro.contribuinte.razao_social}`"
          )
        .divider
      section(v-if="current.items && current.items.length")
        h1.h5 {{ "doc.items" | tModel }}
        .columns
          item-col.my-1.col-6.col-sm-12(
            v-for="item in current.items",
            :key="`${item.codigo}-${item.id}`",
            :label="item.titulo",
            :value="item.valor.formatted"
          )
        .divider
      section(v-if="current.irregularidades && current.irregularidades.length")
        h5.h5 {{ "doc.irregularidades" | tModel }}
        .my-2
        .py-1(v-for="item in current.irregularidades")
          small
            i.fa.fa-check {{ item.descricao }}
        .divider
      section(v-if="current.textos && current.textos.length")
        h5.h5 {{ "doc.textos" | tModel }}
        .my-2.p-2.bg-gray.s-rounded(v-for="texto in current.textos")
          .text-center.mb-2 {{ texto.titulo }}
          .text-long {{ texto.descricao }}
        .divider
      section(v-if="current.termo_textos.length")
        h5.h5 {{ "doc.termo_textos" | tModel }}
        .my-2.p-2.bg-gray.s-rounded(v-for="texto in current.termo_textos")
          .text-center.mb-2 {{ texto.titulo }}
          .text-long {{ texto.descricao }}
        .divider
      section(v-if="current.planilhas && current.planilhas.length")
        h1.h5 {{ "doc.planilhas" | tModel }}
        planilhas(:planilhas="current.planilhas")
      section(v-if="current.cubs && current.cubs.length")
        .divider
        h1.h5 {{ "doc.cubs" | tModel }}
        .columns
          .column.col-8.col-sm-12
            table.table
              thead
                tr
                  th {{ "doc_cub.titulo" | tModel }}
                  th {{ "doc_cub.metros" | tModel }}
                  th {{ "doc_cub.valor_unitario" | tModel }}
                  th.text-right {{ "doc_cub.valor_total" | tModel }}
              tbody
                tr(v-for="cub in current.cubs")
                  td {{ cub.titulo }}
                  td {{ cub.metros | currency("", "m²") }}
                  td {{ cub.valor_unitario | currency("R$ ") }}
                  td.text-right {{ cub.valor_total | currency("R$ ") }}
        .divider
      section(v-if="current.valores && current.valores.length")
        h1.h5 {{ "doc.valores" | tModel }}
        .columns
          item-col.my-1.col-6.col-sm-12(
            v-for="valor in current.valores",
            :key="valor.tipo",
            :label="valor.titulo",
            :value="valor | formatValor"
          )
        .divider
      .columns.pt-1
        .column
          h5.h5 {{ "doc.valor_total" | tModel }}
        .column.col-auto
          h5.h5 {{ (Math.round((current.valor_total || 0.0) * 100) / 100) | currency("R$ ") }}
      section(v-if="current.ordem_servicos && current.ordem_servicos.length")
        .divider
        h1.h5 {{ "doc.ordem_servicos" | tModel }}
        table.table.table-sm
          thead
            tr
              th OS-m
              th {{ "ordem_servico.situacao" | tModel }}
              th {{ "ordem_servico.comentario_situacao" | tModel }}
              th Protocolo
              th {{ "ordem_servico.created_at" | tModel }}
              th.text-right
                span(v-acl:allowed.servicos.show) Ações
          tbody
            tr(v-for="os in current.ordem_servicos")
              td {{ os.numero }}/{{ os.ano }}
              td {{ os | enums("ordem_servico.situacao") }}
              td
                span(v-if="os.comentario_situacao") {{ os.comentario_situacao.descricao }}
                span(v-else) -
              td
                span(v-if="os.protocolo_numero") {{ `${$options.filters.enums(os, "ordem_servico.protocolo_tipo")} - ${os.protocolo_numero}/${os.protocolo_ano}` }}
                span(v-else) -
              td {{ os.created_at | date }}
              td.text-right
                router-link.btn.btn-link.btn-sm(
                  :to="{ name: 'app.osm.servicos.show', params: { id: os.id } }",
                  target="_blank",
                  v-acl:allowed.servicos.show
                )
                  i.fa.fa-eye
      section(v-if="current.pagamentos && current.pagamentos.length")
        .divider
        h1.h5 {{ "doc.pagamentos" | tModel }}
        table.table.table-sm.text-small
          thead
            tr
              th {{ "pagamento.debito_tipo" | tModel }}
              th {{ "pagamento.parcela" | tModel }}
              th {{ "pagamento.pago_em" | tModel }}
              th {{ "pagamento.valor_original" | tModel }}
          tbody
            tr(v-for="pag in current.pagamentos")
              td {{ pag.debito_tipo_id }}
              td {{ pag.parcela }}
              td {{ pag.pago_em | date }}
              td {{ pag.valor_original | currency }}
      .divider
      section.pr-2(v-if="current.comentarios && current.comentarios.length")
        h1.h5 {{ "doc.comentarios" | tModel }}
        row-comentario.my-2.py-2(
          v-for="comentario in current.comentarios",
          :key="comentario.id",
          :comentario="comentario"
        )
        .divider
      section.pr-2(v-if="current.ciencias && current.ciencias.length")
        h1.h5 Ciência
        table.table.table-sm.text-small
          thead
            tr
              th {{ "doc_ciencia.tipo" | tModel }}
              th {{ "doc_ciencia.ciencia_em" | tModel }}
              th {{ "doc_ciencia.assinatura" | tModel }}
              th {{ "origem_registro.ip" | tModel }}
          tbody
            tr(v-for="ciencia in current.ciencias")
              td {{ ciencia | enums("doc_ciencia.tipo") }}
              td {{ ciencia.ciencia_em | date }}
              td {{ ciencia.assinatura }}
              td(v-if="ciencia.origem_registro") {{ ciencia.origem_registro.ip }}
              td(v-else) -
        .divider
      .columns
        .column
        .column.col-auto(v-if="current.url_ar")
          a.btn.btn-link(:href="current.url_ar", target="_blank")
            btn-content(label="Imprimir com AR", icon="fa fa-print")
        .column.col-auto
          router-link.btn.btn-link(
            :to="{ name: 'app.emailHistoricos', params: { scope: 'Doc', scope_id: current.id } }"
          )
            btn-content(name="E-mails", icon="fa fa-envelope-o")
        .column.col-auto
          btn-logs(
            entityName="Doc",
            :entityId="current.id",
            v-acl:allowed.admin.logs.index
          )
        .column.col-auto
          a.btn.btn-link(:href="`${current.url}.pdf`", target="_blank")
            btn-content(label="PDF", icon="fa fa-file-pdf-o")
        .column.col-auto
          doc-actions.dropdown-bottom(:doc="current", :loading="loading")
      router-view
</template>

<script>
import showMixin, { vuexDefaultMapping } from "@/mixins/show"
import RowComentario from "./components/RowComentario.vue"
import DocActions from "./components/DocActions.vue"

export default {
  vuex: {
    "fiscalizacao/docs": vuexDefaultMapping,
  },
  components: { RowComentario, DocActions },
  mixins: [showMixin],
}
</script>

<style lang="stylus" scoped>
.top-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 9;
  padding-top: 5px;
}
</style>
